package com.essntl.features.authentication.ui.auth

import core.validation.Form
import core.validation.field.StringField
import core.validation.validator.NonEmptyValidator

class AuthValidation {
    /**
     * The email is shared between the Register and Login forms.
     */
    val email =
        StringField(NonEmptyValidator)

    val registerForm =
        RegisterForm(email = email)

    val loginForm =
        LoginForm(email = email)
}

class RegisterForm(val email: StringField) : Form() {
    val firstName =
        StringField(NonEmptyValidator)

    val lastName =
        StringField(NonEmptyValidator)

    override val fields = listOf(firstName, lastName, email)
}

class LoginForm(val email: StringField) : Form() {
    val otp =
        StringField(NonEmptyValidator)

    override val fields = listOf(otp, email)
}